<!-- <app-admin-sidebar
  [ngClass]="{ loading: isLoading }"
  [ngStyle]="isLoading ? { border: 'none', 'border-top-color': 'initial' } : {}"
></app-admin-sidebar> -->
<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="track_con">
  <div class="row">
    <div class="col-sm-5 example-field">
      <mat-form-field class="example-full-width text-field">
        <mat-label>Enter Location/Truck Number/Driver Name (ID)</mat-label>
        <input
          class="px-4"
          style="color: black"
          matInput
          [(ngModel)]="truckNo"
          (keyup)="onInputKeyUp($event)"
          (change)="onInputPickUpchange()"
          (input)="onTruckNumberChange($event)"
          #pickUpLocationSearchField
          type="text"
        />
      </mat-form-field>
    </div>
    <div class="col-sm-3 example-field">
      <mat-form-field class="example-full-width">
        <mat-label>Distance(KM)</mat-label>
        <input
          class="px-4"
          matInput
          [(ngModel)]="distanceKM"
          [disabled]="isDistanceFieldDisabled"
        />
      </mat-form-field>
    </div>
    <div class="col-sm-1" *ngIf="search_btn">
      <button
        type="button"
        class="buttonBlue"
        [disabled]="isSearchButtonDisabled"
      >
        <img
          class="search_number"
          (click)="
            !isSearchButtonDisabled ? searchTruckTrackInfo(truckNo, true) : null
          "
          [ngClass]="{ 'disabled-icon': isSearchButtonDisabled }"
          src="../../../assets/img/search-white.svg"
        />
      </button>
    </div>
    <div class="col-sm-1" *ngIf="clear_btn">
      <button type="button" class="buttonBlue" (click)="resetTruckTrackInfo()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
          class="search_number"
        >
          <path
            d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
          />
        </svg>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-9">
      <div tabindex="0" aria-label="Map" class="map booking-map" id="map">
        <div style="width: 100%; height: 450px; position: relative" id="map">
          <div class="loader-container" *ngIf="isLoading">
            <div class="circle-dot-loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>

          <google-map
            height="400px"
            width="750px"
            style="position: absolute; top: 0"
            [center]="center"
            [zoom]="zoom"
          >
            <map-circle [options]="circle"></map-circle>
            <map-marker
              *ngFor="let markerPosition of markerPositions; let i = index"
              [title]="getTooltip(markerPosition)"
              [position]="markerPosition.location"
              [options]="getMarkerOptions(markerPosition)"
              (mapClick)="marker(markerPosition, i)"
            ></map-marker>
          </google-map>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <mat-card class="trucks">
        <div>No Of Trucks Found : {{ trackArray?.length }}</div>
        <mat-divider></mat-divider>
        <div
          class="trucks_Available"
          *ngFor="let items of trackArray; let i = index"
          [ngClass]="{
            selected:
              isSelectedTruck === items.truck_location_history?.vehicleNumber
          }"
        >
          <div (click)="selectTruck(items, false)">
            {{ i + 1 }}.{{
              items.truck_location_history?.vehicleNumber || items.truckNumber
            }}
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<form action="">
  <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" *ngIf="truckStatus">
          <h4 class="modal-title trip">
            {{ arrayMarker?.truckStatus?.toUpperCase() }}
          </h4>
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <div class="modal-header" *ngIf="truckOfflineStatus">
          <h4 class="modal-title trip">
            {{ statusOffline }}
          </h4>
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <div class="modal-header" *ngIf="intransit">
          <h4 class="modal-title trip">ON-TRIP</h4>
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body name">
          <div class="row">
            <div class="col-sm-6">
              <b>Vehicle Number:</b>
              <div class="">{{ arrayMarker?.truckNumber }}</div>
            </div>
            <div class="col-sm-6">
              <b>Driver Name:</b>
              <div class="">
                {{ arrayMarker?.driverName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Trip Id:</b>
              <div class="">{{ arrayMarker?.trip_id }} - {{ arrayMarker?.tripStatus}}</div>

            </div>
            <div class="col-sm-6">
              <b>Mobile Number:</b>
              <div class="">{{ arrayMarker?.driverNumber }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Start Date:</b>
              <div class="">
                {{ arrayMarker?.pickUpdate | date : "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="col-sm-6">
              <b>Last Updated:</b> 
              <div class="">
                {{ arrayMarker?.updateTime | date : "dd-MM-yyyy, hh:mm a" }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Latitude:</b>
              <div class="">{{ arrayMarker?.location?.lat }}</div>
            </div>
            <div class="col-sm-6">
              <b>Longitute:</b>
              <div class="">{{ arrayMarker?.location?.lng }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12"><b>Location:</b>
              <div>{{ arrayMarker?.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- .trucks_Available div:hover {
  color: #f58634; /* Change 'blue' to whatever color you prefer */
} -->
